var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWhenEmpty || _vm.hasContent)?_c('div',{staticClass:"field-display"},[_c('label',{staticClass:"field-display-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"field-display-value"},[_vm._t("default",function(){return [_c('span',{staticClass:"text-pre"},[_vm._v(_vm._s(_vm.displayValue))])]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }